import { render, staticRenderFns } from "./detailsReport.vue?vue&type=template&id=5524aed4&scoped=true&"
import script from "./detailsReport.vue?vue&type=script&lang=js&"
export * from "./detailsReport.vue?vue&type=script&lang=js&"
import style0 from "./detailsReport.vue?vue&type=style&index=0&id=5524aed4&prod&scoped=true&lang=css&"
import style1 from "./detailsReport.vue?vue&type=style&index=1&id=5524aed4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5524aed4",
  null
  
)

export default component.exports